import React, {useState, useEffect} from 'react'
import '../styles/_index.scss'
import {Link} from "react-router-dom"
import {message} from "antd"
import {createShippingRule, listPlatform} from "../../../services/api/apiPacking"
import FormShippingRule from "./templates/FormShippingRule"
import getHistory from "../../../getHistory"

function NewShippingRule() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [platforms, setPlatforms] = useState([])

    async function createRule(data) {
        setLoading(true)
        setError('')

        try {
            const {data: response} = await createShippingRule(data)

            const {success, message: error} = response

            if (!success) {
                setLoading(false)
                setError(error)

                return message.error(error)
            }

            setLoading(false)

            const history = getHistory()
            history.push(`/shipping-rule`)

            message.success('Added rule successfully!')
        } catch (e) {
            setLoading(false)
            setError(e.message)

            message.error(e.message)
        }
    }

    async function getPlatform() {
        try {
            const {data: response} = await listPlatform()

            const {success, message: error, data} = response

            if (!success) {
                return message.error(error)
            }

            setPlatforms(data)
        } catch (e) {
            return message.error(e.message)
        }
    }

    useEffect(() => {
        getPlatform()
        // eslint-disable-next-line
    }, [])

    return (
        <div className="NewShippingRule">
            <div className="BackWrapper">
                <Link to='/shipping-rule'><i className='fa fa-chevron-left'/> Setting shipping rule</Link>
            </div>

            <div className="TitlePage">
                <h1>Add new rule</h1>
            </div>

            <FormShippingRule loading={loading} error={error} platforms={platforms} onCreateShippingRule={createRule}/>
        </div>
    )
}

export default NewShippingRule